// removed by extract-text-webpack-plugin
module.exports = {"on-boarding":"on-boarding","on-boarding-text":"on-boarding-text","arrow-img":"arrow-img"};


//////////////////
// WEBPACK FOOTER
// ./src/template/OnBoardingNatural/onBoarding.scss
// module id = 9U4k
// module chunks = 0